import "./FatFooter.css";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const ThinFooter = () => {
  return (
    <>
      <footer
        className="sticky-footer"
        style={{ margin: "0px", width: "100%" }}
      >
        <Container>
          <Row className="no-gutters">
            <Col lg={12} sm={12} className="text-center">
              <p className="mt-1 mb-0">
                {/*&copy; Copyright 2020{" "}
								<strong className="text-dark">Vidoe</strong>.
								All Rights Reserved
								<br />*/}
                <small className="mt-0 mb-0">
                  ساخته شده توسط{" "}
                  <a
                    className="text-primary-custom"
                    target="_blank"
                    rel="noreferrer"
                    href="https://rasekhoon.net/"
                  >
                    راسخون
                  </a>
                </small>
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default ThinFooter;
